<template >
  <div class="card" v-bind:class="cardType" v-if="showArticle">
    <article-card v-if="articleCard" :cardData=card></article-card>
    <photo-card  v-if="photoCard" :cardData=card></photo-card>
    <tweet-card  v-if="tweetCard" :cardData=card></tweet-card>
    <camera-card v-if="cameraCard" :cardData=card></camera-card>
  </div>
</template>

<script>
  import ArticleCard from '../cards/Article'
  import PhotoCard from '../cards/Photo'
  import TweetCard from '../cards/Tweet'
  import CameraCard from '../cards/Camera'

  export default {
    props: [
      'card'
    ],
    components: {
      ArticleCard,
      PhotoCard,
      TweetCard,
      CameraCard
    },
    computed: {
      cardType () {
        return this.card.type
      },
      filter () {
        return this.$store.getters.filter
      },
      articleCard () {
        if (this.filter === 'all' || this.filter === 'news') {
          return (this.card.type === 'news')
        }
        return false
      },
      photoCard () {
        if (this.filter === 'all' || this.filter === 'social') {
          return (this.card.type === 'flickr')
        }
        return false
      },
      tweetCard () {
        if (this.filter === 'all' || this.filter === 'weather' || this.filter === 'social') {
          if (this.filter === 'weather') {
            return this.card.tags === 'SAWeatherServic'
          }
          return (this.card.type === 'twitter' && this.card.tags !== 'SAWeatherServic')
        }
        return false
      },
      cameraCard () {
        if (this.filter === 'all') {
          return (this.card.type === 'camera')
        }
        return false
      },
      userInterests () {
        if (this.$store.getters.user) {
          return this.$store.getters.user.interests.map((interest) => {
            return interest.name.toLowerCase()
          })
        }

        return null
      },
      showArticle () {
        if (this.articleCard || this.photoCard || this.tweetCard || this.cameraCard) {
          if (this.card.type !== 'news' || this.userInterests === null) {
            return true
          }
          return this.userInterests.filter(value => this.card.tags.includes(value)).length > 0
        }
        return false
      }
    },
    mounted: function () {
      // console.log(this.card)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/HomeCardListItem.vue